import {Dimensions} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import {OverlayModal} from '../../OverlayModal';

const {height: screenHeight} = Dimensions.get('window');

//@ts-ignore
export const Container = styled(OverlayModal)`
  justify-content: flex-end;
  margin: 0;
`;

export const ModalContent = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  padding: ${RFValue(18)}px ${RFValue(16)}px;
  padding-bottom: ${RFValue(24)}px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  max-height: ${screenHeight * 0.7}px;
`;

export const ModalHeader = styled.View`
  margin-bottom: ${RFValue(8)}px;
`;

export const ModalTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ModalSubtitle = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const InstallmentList = styled.ScrollView`
  flex-shrink: 1;
`;

export const EmptyText = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;
